import { useEffect } from 'react'
import styled from 'styled-components'
import DaumPostcode from 'react-daum-postcode'

type AddressFinderModalProps = {
  visible: boolean
  onClose: () => void
  onComplete: (data: any) => void
}

const AddressFinderModal = ({ visible, onClose, onComplete }: AddressFinderModalProps) => {
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [visible])

  if (!visible) return null

  return (
    <Dim>
      <PopupWrap>
        <PopupHeader>
          <button title='닫기' onClick={onClose}>
            <img src='/images/icon_close.png' alt='닫기' />
          </button>
        </PopupHeader>

        <PopupContent>
          <DaumPostcode onComplete={onComplete} style={{ height: '100%', margin: '0 auto' }} />
        </PopupContent>
      </PopupWrap>
    </Dim>
  )
}

const Dim = styled.div`
  position: fixed;
  inset: 0;
  width: 100dvw;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
`

const PopupWrap = styled.div`
  background: var(--colWhite, #fff);
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  width: 98dvw;
  max-width: 480px;
  min-width: 320px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const PopupHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 5px 0 0;
  background: transparent;
  button {
    background: none;
    border: none;
    cursor: pointer;
    width: 48px;
    height: 48px;
    padding: 12px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`

const PopupContent = styled.div`
  width: 100%;
  height: 390px;
  padding: 0 0 20px 0;
  box-sizing: border-box;
  border-top: 1px solid var(--colGray3);
  background: var(--colWhite, #fff);
`

export default AddressFinderModal
